import axios from 'axios';
import {
  DATA_EXPORT_REQUEST,
  DATA_EXPORT_SUCCESS,
  DATA_EXPORT_FAIL,
  DATA_IMPORT_REQUEST,
  DATA_IMPORT_SUCCESS,
  DATA_IMPORT_FAIL,
  GET_COLLECTIONS_REQUEST,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAIL,
  GET_COLLECTION_COUNT_REQUEST,
  GET_COLLECTION_COUNT_SUCCESS,
  GET_COLLECTION_COUNT_FAIL,
  CLEAR_DATA_OPERATIONS
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get available collections
export const getCollections = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_COLLECTIONS_REQUEST });

    const res = await axios.get('/api/data-import-export/collections', tokenConfig(getState));

    dispatch({
      type: GET_COLLECTIONS_SUCCESS,
      payload: res.data
    });
  } catch (error) {
    const message = error.response?.data?.msg || error.message || 'Failed to get collections';
    dispatch({
      type: GET_COLLECTIONS_FAIL,
      payload: message
    });
    dispatch(returnErrors(error.response?.data, error.response?.status));
  }
};

// Export data
export const exportData = (exportConfig) => async (dispatch, getState) => {
  try {
    dispatch({ type: DATA_EXPORT_REQUEST });

    const res = await axios.post('/api/data-import-export/export', exportConfig, tokenConfig(getState));

    // Create and download JSON file
    const dataStr = JSON.stringify(res.data, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `lms-export-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    dispatch({
      type: DATA_EXPORT_SUCCESS,
      payload: {
        message: 'Data exported successfully',
        exportInfo: res.data.metadata
      }
    });
  } catch (error) {
    const message = error.response?.data?.msg || error.message || 'Export failed';
    dispatch({
      type: DATA_EXPORT_FAIL,
      payload: message
    });
    dispatch(returnErrors(error.response?.data, error.response?.status));
  }
};

// Import data
export const importData = (importConfig) => async (dispatch, getState) => {
  try {
    dispatch({ type: DATA_IMPORT_REQUEST });

    const res = await axios.post('/api/data-import-export/import', importConfig, tokenConfig(getState));

    dispatch({
      type: DATA_IMPORT_SUCCESS,
      payload: res.data
    });

    return res.data;
  } catch (error) {
    const message = error.response?.data?.msg || error.message || 'Import failed';
    dispatch({
      type: DATA_IMPORT_FAIL,
      payload: message
    });
    dispatch(returnErrors(error.response?.data, error.response?.status));
    throw error;
  }
};

// Get collection document count
export const getCollectionCount = (collectionName) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_COLLECTION_COUNT_REQUEST });

    const res = await axios.get(`/api/data-import-export/collection/${collectionName}/count`, tokenConfig(getState));

    dispatch({
      type: GET_COLLECTION_COUNT_SUCCESS,
      payload: res.data
    });
  } catch (error) {
    const message = error.response?.data?.msg || error.message || 'Failed to get collection count';
    dispatch({
      type: GET_COLLECTION_COUNT_FAIL,
      payload: message
    });
    dispatch(returnErrors(error.response?.data, error.response?.status));
  }
};

// Clear data operations state
export const clearDataOperations = () => dispatch => {
  dispatch({ type: CLEAR_DATA_OPERATIONS });
};
